import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import Button from '../../Common/Button';
import ConfigService from "../../../Services/api/Config";
import Icon from "../../Common/Icon";
import {ReactComponent as InfoIcon} from "../../../../img/icon-info.svg";
import {ReactComponent as CloseIcon} from "../../../../img/dialog-close.svg";

class ModalSkipDynamicForm extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  onPressClose = (event) => this.props.onClose(event);

  onPressSave = async (event) => {
    this.props.onSubmit();
    this.props.onClose();
  };

  render() {

    const { name } = this.props;

    return (
      <Modal
        isOpen
        onRequestClose={ this.onPressClose }
        contentLabel='Skip Dynamic Form'
        className='Modal_Content'
        overlayClassName='Modal_Overlay'
      >
        <div className='Modal_Content_Container Center'>
          <h2>
            SKIP DYNAMIC FORM { name && '"' + name + '"'}
          </h2>
          <div className='Warning_Container' style={ { color: ConfigService.getColor('warningColor') } }>
            <div className="Table">
              <div className="TableCell Align-Top">
                <Icon className='Icon-Warning' width='16' height='16' color='warningColor'>
                  <InfoIcon alt='icon-info'/>
                </Icon>
              </div>
              <div className="TableCell">
                <p>Are you sure you want to skip this form?</p>
                <p>Any unsaved information will be discarded.</p>
              </div>
            </div>
          </div>
          <div className='Modal_Content_Actions Center'>
            <Button className='Button_Delete Inline'
              onClick={ this.onPressSave  }
            >
              Yes, skip
            </Button>
            <Button className='Button_Cancel Inline'
              onClick={ this.onPressClose }
            >
              Cancel
            </Button>
          </div>
          <div className='Modal_Content_Close' onClick={ this.onPressClose }>
            <Icon className='Icon-Close' width='12' height='12' color='secondaryColor'>
              <CloseIcon alt='icon-close'/>
            </Icon>
          </div>
        </div>
      </Modal>
    );
  }
}

ModalSkipDynamicForm.propTypes = {
  name: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default ModalSkipDynamicForm;
